import { ACTIVATE_OVERLAY, DEACTIVATE_OVERLAY } from "./types";

const getInitialState = () => {
  const found = initialState.find(item => {
    return item.ui;
  });
  return found ? found.ui.overlay : {};
};

export default (state = getInitialState(), action) => {
  switch (action.type) {
    case ACTIVATE_OVERLAY:
      return {
        ...state,
        active: true,
        activeId: action.payload.id,
        triggered: action.payload.triggered
      };
    case DEACTIVATE_OVERLAY:
      return {
        ...state,
        active: false,
        activeId: ""
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/services/ui/overlay/reducer.js